<header-title [model]="headerTitle"></header-title>

<section class="card">
    <header class="card-header">
        <h3 class="text-gray-600 m-0"><i class="fas fa-question me-2"></i>Create New Question</h3>
    </header>

    <div class="card-body py-5">
        <div class="container">
            <form (submit)="addQuestion()" [formGroup]="addQuestionFormGroup">
                <fieldset>
                    <div class="panel-body">
                        <error-message [errors]="errors"></error-message>
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <label class="control-label text-primary">Title</label>
                                <ckeditor [editor]="title" (change)="changeTitle($event)" [(ngModel)]="titleData" [ngModelOptions]="{standalone: true}"></ckeditor>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-4">
                                <label class="control-label text-primary">Response Type</label>
                                <select name="responseTypeId" class="form-select" formControlName="responseTypeId">
                                    <option [value]="''">--Select Response Type--</option>
                                    <option *ngFor="let responseType of responseTypes" value="{{responseType.id}}">{{responseType.title}}</option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <label class="control-label text-primary">Weighting</label>
                                <input type="number" class="form-control" formControlName="weighting" value="1" min="1" max="3" />
                                <div class="text-info">
                                    Default = 1, High = 2, Critical = 3
                                </div>
                            </div>
                            <div class="col-md-3">
                                <label class="control-label text-primary">
                                    Is Active
                                </label>
                                <input type="checkbox" id="isActive" name="isActive" class="form-control" formControlName="isActive" appToggle />
                            </div>
                        </div>
                    </div>
                    <footer class="panel-footer mt-3">
                        <div class="row">
                            <div class="col text-end">
                                <button class="btn btn-outline-primary ms-2" type="button" (click)="onBack()">Back</button>
                                <button class="btn btn-success ms-2" type="submit">Create</button>
                            </div>
                        </div>
                    </footer>
                </fieldset>
            </form>
        </div>
    </div>
</section>
